import { getDashboardPath } from "@/lib/authRoutes";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Skeleton } from '@/components/ui/skeleton';

interface ProtectedRouteProps {
  allowedRoles: ('candidate' | 'company')[];
}

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const { profile, loading, session } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Skeleton className="w-32 h-32 rounded-full" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!profile || !allowedRoles.some(role => role === profile.role)) {
    return <Navigate to={getDashboardPath(profile?.role) ?? "/login"} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;